export function useUploadQueue(maxConcurrent = 3) {
  const uploadQueue: (() => Promise<void>)[] = []
  const activeUploads = ref(0)

  function runNextUpload() {
    if (activeUploads.value >= maxConcurrent) return
    const next = uploadQueue.shift()
    if (!next) return

    activeUploads.value++
    next().finally(() => {
      activeUploads.value--
      runNextUpload() // trigger next queued upload
    })
  }

  function enqueueUpload(job: () => Promise<void>) {
    uploadQueue.push(job)
    runNextUpload()
  }

  return {
    enqueueUpload,
    activeUploads,
    uploadQueue,
  }
}
